export enum GridColumnType {
    None = 0,
    Attribute = 1,
    DeviceName = 2,
    Sparkline = 3,
    Date = 4
}
